import Language from "../language/Language";
import { getLanguageFromCode } from "../voice/languages";
import i18n from "../../i18n";

export default class Group {
  id: number;
  collectionId: number;
  title: string;
  termCount: number;
  language?: Language | undefined;
  learningPercentange: number;
  selected: boolean = false;
  isAllGroup: boolean = false;
  isUnspecifiedGroup: boolean = false;

  constructor(
    id: number,
    collectionId: number,
    title: string,
    termCount: number,
    language: string,
    learningPercentange: number
  ) {
    this.id = id;
    this.collectionId = collectionId;
    this.title = title;
    this.termCount = termCount;
    this.language = getLanguageFromCode(language);
    this.learningPercentange = learningPercentange;
  }

  static fromJson(json: any): Group {
    let groupName = json.gn;
    if (groupName === undefined || groupName.length === 0) {
      groupName = i18n.t("NoSelectGroup");
    }

    return new Group(
      json.id,
      json.collectionId,
      groupName,
      json.termCount,
      json.lang,
      json.learningPercentage
    );
  }
}

export function getAllGroup(groups: Group[]): Group {
  const groupName = i18n.t("AllGroups");
  const termCount = groups
    .map((g) => g.termCount)
    .reduce((acc, cur) => acc + cur, 0);
  const percentange = groups
    .map((g) => g.learningPercentange)
    .reduce((acc, cur) => acc + cur, 0);

  const group = new Group(0, 0, groupName, termCount, "", percentange);
  group.isAllGroup = true;
  return group;
}
